export default __webpack_public_path__ + "static/svyat-8e7c5b86feb3461e976763e18a3eab76.png";